var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MuiIconButton, MuiRightDrawer } from "../../../../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiBox } from "../../../../../../components";
import { APISchema, ElabelStyling, LOCAL_STORAGE_KEYS } from "../../../../../../constants";
import { setState } from "../../../../../../redux/crudSlice";
import { useAppSelector } from "../../../../../../store/hooks";
import { systemColor } from "../../../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../../../utils/storageHelper";
// import { CrossIcon } from "../../../../../spareIssue/assets";
import { getWarehouseListAPICall } from "../../../../../spareIssue/services/apiCalls";
import { SpareIssuesKeys } from "../../../../../spareIssue/services/entity";
import { statusListGet } from "../../../../../stockAdjustment/apiCall";
import { procurementPriorityListAPICall, proxyListAPICall } from "../../../../purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../../../purchaseRequistion/services/entity";
import { CrossIcon } from "../../../../../../assets/images";
export var OutwardFilterBtoB = function (props) {
    var _getLocalStorageItem, _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2;
    var isFilterOpen = props.isFilterOpen, setFilterOpen = props.setFilterOpen;
    var _a = useState(""), dateRange = _a[0], setDateRange = _a[1];
    var _b = useState(), fromDate = _b[0], setFromDate = _b[1];
    var _c = useState(), ToDate = _c[0], setToDate = _c[1];
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    useEffect(function () {
        getWarehouseListAPICall({
            request: {
                TenantId: UserOrganization
            }
        });
    }, []);
    var handleApplyClick = function (event, values) {
        var _values$FromDate, _values$ToDate;
        var req = {
            DateRange: values === null || values === void 0 ? void 0 : values.DateRange,
            Status: values === null || values === void 0 ? void 0 : values.Status,
            Type: 'BToBRequisition',
            SourceTenantId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.OrganizationId,
            SourceParentTenantId: UserOrganization === null || UserOrganization === void 0 ? void 0 : UserOrganization.ParentOrganizationId,
            SourceWarehouseId: values === null || values === void 0 ? void 0 : values.SourceWarehouseId,
            DestinationWarehouseId: values === null || values === void 0 ? void 0 : values.DestinationWarehouseId,
            TransporterId: values === null || values === void 0 ? void 0 : values.TransporterId,
            FromDate: fromDate ? fromDate : (_values$FromDate = values === null || values === void 0 ? void 0 : values.FromDate) !== null && _values$FromDate !== void 0 ? _values$FromDate : "",
            ToDate: ToDate ? ToDate : (_values$ToDate = values === null || values === void 0 ? void 0 : values.ToDate) !== null && _values$ToDate !== void 0 ? _values$ToDate : ""
        };
        dispatch(setState({
            key: "filterValue",
            value: {
                data: req,
                success: true
            }
        }));
        setFilterOpen(false);
    };
    var getStatusListBtSystemName = function (params) { return statusListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            SystemName: APISchema.StockTransferRequisition
        })
    })); };
    var handleRangeChange = function (range) {
        var currentDate = new Date();
        switch (range) {
            case 'Weekly':
                var nextWeekDate = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextWeekDate);
                return nextWeekDate;
            case 'Monthly':
                var nextMonthDate = new Date(currentDate.getTime() + 30 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextMonthDate);
                return nextMonthDate;
            case 'Yearly':
                var nextYearDate = new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
                setFromDate(currentDate);
                setToDate(nextYearDate);
                return nextYearDate;
            case 'Custom':
                return 'Custom';
            default:
                return null;
        }
    };
    var formData = [{
            type: FormItemTypes.Custom,
            name: 'Header',
            label: '',
            element: function () { /*#__PURE__*/ return React.createElement(MuiBox, null, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                spacing: 5,
                paddingTop: IS_DESKTOP ? 8 : 0,
                paddingBottom: 3
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 10
            }, /*#__PURE__*/ React.createElement(Typography, {
                style: {
                    fontSize: '16px',
                    fontWeight: '600'
                },
                color: "black"
            }, t("Filters")), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                color: '#8593A3'
            }, t("Apply filters to table data."))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 2
            }, /*#__PURE__*/ React.createElement(MuiIconButton, {
                onClick: function () { return setFilterOpen(false); },
                style: {
                    justifyContent: 'flex-end'
                },
                id: "cancelButton"
            }, /*#__PURE__*/ React.createElement("img", {
                id: "crossIconBtn",
                src: CrossIcon
            }))))); },
            value: null,
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            label: '',
            value: null,
            columnSize: 12,
            sx: {
                marginBottom: '20px',
                flexGrow: 1,
                overflowY: 'auto',
                padding: '16px'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'FilterName',
                    label: '',
                    displayExpr: "Name",
                    placeholder: "Select saved filter",
                    disabled: true,
                    valueExpr: "id",
                    apiKey: PurchaseRequisitionKeys.ProxyList,
                    getListData: proxyListAPICall,
                    // startAdornment: <img src={FilterLineIcon} style={{ margin: 3 }} />, prop removed to fix multiselect issue
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Source Warehouse',
                    displayExpr: "DisplayName",
                    options: (_crud$SpareIssuesKeys = crud[SpareIssuesKeys.WarehouseList]) === null || _crud$SpareIssuesKeys === void 0 ? void 0 : _crud$SpareIssuesKeys.data,
                    labelTypographyProps: ElabelStyling,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DestinationWarehouseId',
                    label: 'Destination Warehouse',
                    displayExpr: "DisplayName",
                    options: (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.WarehouseList]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data,
                    labelTypographyProps: ElabelStyling,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Status',
                    label: 'Status',
                    multiple: true,
                    getListData: getStatusListBtSystemName,
                    labelTypographyProps: ElabelStyling,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Priority',
                    getListData: procurementPriorityListAPICall,
                    multiple: true,
                    label: 'Priority',
                    labelTypographyProps: ElabelStyling,
                    valueExpr: "id",
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DateRange',
                    label: 'Date range',
                    labelTypographyProps: ElabelStyling,
                    options: [{
                            id: 1,
                            name: 'Weekly'
                        }, {
                            id: 2,
                            name: 'Monthly'
                        }, {
                            id: 3,
                            name: 'Yearly'
                        }, {
                            id: 4,
                            name: 'Custom'
                        }],
                    onChange: function (event, value) {
                        setDateRange(value === null || value === void 0 ? void 0 : value.name);
                        handleRangeChange(value === null || value === void 0 ? void 0 : value.name);
                        if (value == null) {
                            setFromDate('');
                            setToDate('');
                        }
                    },
                    setFormState: function () { return ({
                        FromDate: null,
                        ToDate: null
                    }); },
                    valueExpr: "id",
                    displayExpr: 'name',
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'SelectSpareIssueDate',
                    label: 'Spare Issue Data',
                    value: null,
                    elements: __spreadArray([], (dateRange === 'Custom' ? [{
                            type: FormItemTypes.Typography,
                            name: 'SelectSpareIssueDateTypography',
                            label: 'Date',
                            value: null,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'FromDate',
                            label: '',
                            placeholder: "From",
                            value: null,
                            columnSize: 6
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ToDate',
                            label: '',
                            placeholder: "To",
                            value: null,
                            columnSize: 6
                        }] : []), true),
                    columnSize: 12,
                    sx: {}
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            label: '',
            value: null,
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '100%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 1000,
                paddingBottom: '16px',
                borderTop: "1px solid #DEE4EB"
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save Filter',
                    label: '',
                    children: 'Save Filter',
                    value: null,
                    disabled: true,
                    xs: 4,
                    sm: 4,
                    md: 4,
                    lg: 4
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'saveButton',
                    label: '',
                    value: null,
                    xs: 8,
                    sm: 8,
                    md: 8,
                    lg: 8,
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'discard',
                            label: '',
                            children: 'Reset Filters',
                            onClick: function () {
                                return 'reset';
                            },
                            value: null,
                            id: "discard",
                            xs: 7,
                            sm: 7,
                            md: 7,
                            lg: 7,
                            sx: {
                                border: '1px solid #DEE4EB',
                                marginLeft: '2px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            label: '',
                            children: 'Apply',
                            value: null,
                            xs: 2,
                            sm: 2,
                            md: 2,
                            lg: 2,
                            onClick: handleApplyClick,
                            sx: {
                                border: '1px solid #DEE4EB',
                                backgroundColor: systemColor.primary,
                                color: '#FFFFFF',
                                ":hover": {
                                    color: systemColor.primary
                                }
                            }
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: isFilterOpen,
        onClose: function () {
            setFilterOpen(false);
            setDateRange("");
        },
        sx: {
            width: {
                xs: '100%',
                sm: "400px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            p: 1.5
        },
        getKey: "filterValue",
        mode: "edit"
    }));
};
